import { render, staticRenderFns } from "./UpdateVehicule.vue?vue&type=template&id=56b4f981&"
import script from "./UpdateVehicule.vue?vue&type=script&lang=js&"
export * from "./UpdateVehicule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports